export const getEventsValue = (propertiesArray, eventsArray, eventsSelectedByTimeProperties) => {
  let properties = propertiesArray.slice(0, 1);
  let events = [];
  let eventsDropDown = [];
  for (var i = 0; i < propertiesArray.length; i++) {
    let _events = eventsArray.find(e => e.id === propertiesArray[i]);
    let allEvents = eventsSelectedByTimeProperties.find(e => e.id === propertiesArray[i])
    properties = [propertiesArray[i]]
    eventsDropDown = (allEvents && allEvents.list && allEvents.list.length > 0) ? allEvents.list : []
    if (_events && _events.list && _events.list.length > 0) {
      return {
        properties: [propertiesArray[i]],
        events: _events.list,
        eventsDropDown: eventsDropDown
      }
    }
  }
  return {
    properties,
    events,
    eventsDropDown
  }
}

export const tabValues = [
  "Overview",
  "Properties Breakdown",
  "Events Breakdown",
  "Invitees Status",
];

export const getInviteesDefaultValue = (eventsById) => {
  if (eventsById.length > 0 && eventsById[0].list && eventsById[0].list.length > 0) {
    let list = [eventsById[0].list[0].id];
    let obj = {
      id: eventsById[0].id,
      list,
    };
    return [obj];
  } else {
    return [];
  }
};